module.exports = __webpack_public_path__ + "img/SummaryBanner.8dd7b3ec.png";